import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as organization from '../../../../organization'
import * as employee from '../employee'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: employee.RESOURCE.payload.dimension.partialId,
      partialId: employee.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Main organization unit that this employee is assigned to',
    isOptional: false,
    name: 'Primary Organization',
    partialId: PartialId.Standard.create('org'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(
        organization.RESOURCE.payload,
      ),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
